<div class="row"
  style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important">
  <div class="col-11"></div>
  <h2>{{labels.lblExpiredUser}}</h2>
</div>

<div class="row" style="margin-top: 15px;">

  <div class="col-4 div" style="padding: 7px;">
    <button (click)="onNoClick()" class="tableBtn btnInstruction">
      {{labels.lblLogOut}}
    </button>
  </div>
</div>
